import React, { Component } from 'react'

class ToastElement extends Component {
  render() {
    const {alert} = this.props;
    return (
      <span id={alert.key}><a href={alert.link || ""}  className={"text-white font-weight-bold"} alt={alert.key}>{alert.text}</a></span>
    )
  }
}

export default ToastElement


// WEBPACK FOOTER //
// ./src/components/Header/_ToastElement.js